import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 font-bold text-gray-800" }
const _hoisted_2 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_3 = { class: "text-gray-800" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex justify-center" }

import { computed } from "vue";
import DialogModal from "@/components/Modal/DialogModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ItensObrigatoriosModal',
  props: {
    show: { type: Boolean },
    instrucoes: null,
    nomeSetor: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean;
  instrucoes: string;
  nomeSetor: string;
};



const instrucoesAjustadas = computed(() =>
  (props.instrucoes ?? "").replace(/<img\s/gi, '<img class="mx-auto w-auto max-h-55vh" ')
);



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(DialogModal, {
    show: __props.show,
    "max-width": "4xl",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: "exclamation-triangle",
          class: "text-orange-500"
        }),
        _createTextVNode(" Itens obrigatórios para acesso à empresa ")
      ]),
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(" Setor: "),
        _createElementVNode("b", _hoisted_3, _toDisplayString(__props.nomeSetor), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: "max-h-60vh overflow-y-auto space-y-2 text-sm text-gray-800",
        innerHTML: _unref(instrucoesAjustadas)
      }, null, 8, _hoisted_4)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "w-full sm:w-auto flex items-center justify-center gap-2 whitespace-nowrap px-4 sm:px-10 py-3 text-base sm:text-lg text-white font-semibold rounded-lg shadow-md hover:shadow-lg bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-green-300 transition-all duration-200",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "check" }),
          _createTextVNode(" Estou ciente, prosseguir ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})